import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { NurseInclusionPreIncludedBy } from "@/models/NurseInclusionPatientModel.ts";
import { userFormattedName } from "@/models/UserModel.ts";
import { ProfilePicture } from "@/uiKit/atoms/ProfilePicture.tsx";

export type NurseInclusionSourceProps = {
  id?: string;
  nurse: NurseInclusionPreIncludedBy;
  className?: string;
};

export const NurseInclusionSource: React.FC<NurseInclusionSourceProps> = ({ id, nurse, className }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <ProfilePicture
      id={id}
      className={cx(styles.profilePicture, className)}
      src={nurse.profilePicture?.url}
      firstName={nurse.firstName}
      lastName={nurse.lastName}
      tooltip={t("nurseInclusion.inclusionProposalBy", {
        nurse: userFormattedName(nurse.lastName, nurse.firstName),
      })}
      size="scale"
      tooltipWrapperClassName={styles.tooltipWrapper}
      tooltipClassName={styles.tooltip}
    />
  );
};

const makeStyles = () => ({
  profilePicture: css({
    height: "100%",
    width: "auto",
    display: "flex",
    flex: "1 1 0",
  }),
  tooltip: css({
    display: "flex",
  }),
  tooltipWrapper: css({
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
  }),
});
